package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class StudentResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("class_name")
    val className: String? = null,
    @SerialName("section_name")
    val sectionName: String? = null,
    @SerialName("current_class_section_id")
    val currentClassSectionId: String? = null,
    @SerialName("admission_number")
    val admissionNumber: String? = null,
    @SerialName("roll_number")
    val rollNumber: String? = null,
    @SerialName("name")
    val name: String? = null,
    @SerialName("dob")
    val dob: String? = null,
    @SerialName("gender")
    val gender: String? = null,
    @SerialName("blood_group")
    val bloodGroup: String? = null,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, JsonElement>? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null
)

@Serializable
data class StudentSubjectListResponse(
    @SerialName("enrollment_id") val enrollmentId: String? = null,
    @SerialName("class_subject_link_id") val classSubjectLinkId: String? = null,
    @SerialName("subject_id") val subjectId: String? = null,
    @SerialName("subject_code") val subjectCode: String? = null,
    @SerialName("subject_name") val subjectName: String? = null,
    val category: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null
)

@Serializable
data class StudentParentListResponse(
    @SerialName("link_id") val linkId: String? = null,
    @SerialName("parent_id") val parentId: String? = null,
    @SerialName("name") val name: String? = null,
    @SerialName("relationship_type") val relationshipType: String? = null,
    @SerialName("is_primary_contact") val isPrimaryContact: Boolean? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("mobile") val mobile: String? = null,
    @SerialName("email") val email: String? = null
)

@Serializable
data class StudentParentLinkResponse(
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("parent_id") val parentId: String? = null,
    @SerialName("relationship_type") val relationshipType: String? = null,
    @SerialName("is_primary_contact") val isPrimaryContact: Boolean? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("id") val id: String? = null,
    @SerialName("created_at") val createdAt: String? = null
)

@Serializable
data class StudentListResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("class_name")
    val className: String? = null,
    @SerialName("section_name")
    val sectionName: String? = null,
    @SerialName("admission_number")
    val admissionNumber: String? = null,
    @SerialName("roll_number")
    val rollNumber: String? = null,
    @SerialName("name")
    val name: String? = null,
    @SerialName("dob")
    val dob: String? = null,
    @SerialName("gender")
    val gender: String? = null,
    @SerialName("blood_group")
    val bloodGroup: String? = null,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, JsonElement>? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("created_by_name")
    val createdByName: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null,
    @SerialName("updated_by_name")
    val updatedByName: String? = null,
    @SerialName("subjects")
    val subjects: List<StudentSubjectListResponse>? = null,
    @SerialName("parents")
    val parents: List<StudentParentListResponse>? = null
)
